import { render, staticRenderFns } from "./CopyrightAssignmentTransferTask.vue?vue&type=template&id=0b73a024&scoped=true&"
import script from "./CopyrightAssignmentTransferTask.vue?vue&type=script&lang=js&"
export * from "./CopyrightAssignmentTransferTask.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightAssignmentTransferTask.vue?vue&type=style&index=0&id=0b73a024&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b73a024",
  null
  
)

export default component.exports